"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const actions_1 = require("./actions");
const initialState = {
    movieInfo: null,
    loading: false
};
function putMovieInfo(state, action) {
    return {
        ...state,
        movieInfo: action.movieInfo,
        loading: false
    };
}
function reducer(state = initialState, action) {
    switch (action.type) {
        case actions_1.actions.REQUEST_MOVIE_INFO:
            return { ...state, loading: true };
        case actions_1.actions.PUT_MOVIE_INFO:
            return putMovieInfo(state, action);
        default: return state;
    }
}
exports.reducer = reducer;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-store/movie/reducer.ts